import ManualBillingDocumentInCart from '@/generated/controls/manualBillingDocument/ManualBillingDocumentInCart.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentInCart
})
